import { Component, OnInit, Input, OnDestroy, OnChanges, SimpleChanges, Output, EventEmitter, ChangeDetectorRef } from '@angular/core';

import { FechasService } from 'src/app/services/fechas/fechas';

import { ImprimiService } from 'src/app/services/imprimir/imprimirService';
import { FirmaService } from 'src/app/services/firma/firmaService';
import { estilos_informes } from 'src/app/config/estilos-informes';
import { logo } from 'src/app/config/imagenes';
import { ImageBaseService } from 'src/app/services/imagenes/imagenes.service';
import { url } from 'src/app/config/config';
import { GenericService } from 'src/app/services/generic/generic.service';


declare var $: any;



@Component({
    selector: 'app-imprimir-pesos',
    templateUrl: './imprimir-pesos.component.html',
    styleUrls: ['./imprimir-pesos.component.css'],
    providers: [ImprimiService, FirmaService]

})
export class ImprimirPesosComponent implements OnInit, OnDestroy, OnChanges {



    @Input() title: string;
    @Input() id: string;
    @Input() database: string;
    @Output() cerrarVentana = new EventEmitter();
    public firma = '';
    public firma_revision = '';
    public revision = '';
    public baseUrl = url + "upload/firmas/";
    public baseEtiqueta = url + "upload/envasado_bolsa/";
    public rev: string = '';

    public anexo = new Date();
    public productos: any = [];
    public oldId = "";
    public oldDatabase = "";
    public productosKey: any[] = [];
    public estructurado: any[] = [];
    public fechaActual = this.fechaService.mostrarFechaActual();
    public closeWindow = true;
    public pesos: any[] = [];

    public arrayPesos: any[] = [];
    public url: string = url + "upload/pesos/pitufo/";
    public imgURL: any = "https://via.placeholder.com/150/808080/FFFFFF?Text=Digital.com";
    public responsable: string = '';
    public observaciones = '';
    public contador_pesos: string = '4';
    public logo: string = "";
    nuevaEtiqueta: Object;
    etiquetaFile: File;
    public procedimientos: string = '08';
    public reg: string = '14';

    constructor(
        private fechaService: FechasService,
        private firmaService: FirmaService,
        private imprimirService: ImprimiService,
        private genericService: GenericService,
        private ImageBaseService: ImageBaseService,
        private cd: ChangeDetectorRef
        ) {
        this.oldId = this.id;
    }
    public myMap = new Map([]);
    ngOnInit(): void {
        this.logo = logo;
       /*  this.ImageBaseService.image64(logo).toPromise()
        .then( (resp: string) => {
           
            this.logo = resp;
        }).catch( error => {
            this.logo = logo;
        }); */
        // this.mostrarContenido();


    }
    ngOnDestroy(): void {

    }
    ngOnChanges(changes: SimpleChanges) {
        this.mostrarContenido();
        if (this.id) {
            if (this.oldId != this.id) {
                this.pesos = [];
                this.mostrarContenido();
            }

        } else {

        }

    }
   
    mostrarContenido() {

        this.firma_revision = '';
        this.revision = '';

        this.genericService.getId(this.id, this.database).subscribe((resp: any) => {
            // console.log("database ",this.database);

             // console.log("informes pesos ", resp);
             this.productos = resp.etiqueta;
            try {
                if (this.productos[0].archivo == null || this.productos[0].archivo == undefined) {
                    this.imgURL = '';
                } else {
                  this.imgURL = this.url + resp[0].etiqueta_archivo; 
                }
            } catch( error) { 
                this.imgURL = '';
            }

            try {
                // console.log('this.productos[0]', this.productos[0]);
                
                this.responsable = this.productos[0].myResponsable;
                this.firmaService.getFirma(this.responsable).toPromise().then((data: any) => {
                   
                    if ( this.responsable ) {
                        this.firma = this.baseUrl + data.productos[0].firma;
                        /* this.ImageBaseService.image64(this.firma).toPromise().
                          then((imagen64) => {
                          
                            this.nuevaEtiqueta = imagen64;
                            
                            this.etiquetaFile = this.dataURLtoFile(imagen64, 'imagen.jpeg');
                            this.handleFiles(this.etiquetaFile, 'this.firma').then(resolve => {
                              this.firma = resolve.toString();
                            });
                          }); */
        
                      } else {
                        //console.log("no hay firma");
        
                        this.firma = null;
                      }

                }).catch(error => {
                    //console.log("error ",error);
                    this.firma = null;
                });
                this.revision = this.productos[0].revision;
                this.firmaService.getFirma(this.productos[0].revision).toPromise().then((data: any) => {
                     // console.log("data",data);
                    if (data.productos[0].firma) {
                        this.firma = this.baseUrl + data.productos[0].firma;
                        /* this.ImageBaseService.image64(this.firma).toPromise().
                          then((imagen64) => {
                            // console.log('resp 64', imagen64);
                            this.nuevaEtiqueta = imagen64;
                            // console.log(this.dataURLtoFile( imagen64, 'imagen.jpeg'));
                            this.etiquetaFile = this.dataURLtoFile(imagen64, 'imagen.jpeg');
                            this.handleFiles(this.etiquetaFile, 'this.firma').then(resolve => {
                              this.firma_revision = resolve.toString();
                            });
                          }); */
        
                      } else {
                        //console.log("no hay firma");
        
                        this.firma_revision = null;
                      }

                }).catch(error => {
                    //console.log("error ",error);
                    this.firma_revision = null;
                });
            } catch (error) {
                this.firma = null;
            }
           let archivo = this.productos[0].archivo;
           try {
            if (archivo) {
                this.imgURL = this.baseEtiqueta + archivo;
                /* this.ImageBaseService.image64(this.imgURL).toPromise().
                  then((imagen64) => {
                    // console.log('resp 64', imagen64);
                    this.nuevaEtiqueta = imagen64;
                    // console.log(this.dataURLtoFile( imagen64, 'imagen.jpeg'));
                    this.etiquetaFile = this.dataURLtoFile(imagen64, 'imagen.jpeg');
                    this.handleFiles(this.etiquetaFile, 'archivo').then(resolve => {
                      this.imgURL = resolve.toString();
                    });
                  }); */

              } else {
                //console.log("no hay firma");

                this.imgURL = null;
              }
           } catch (error) {
               
           }
          
            this.observaciones = this.productos[0]['observaciones'];
            let recogerPalabra = "";
            let recogercadenas = [];

            let separarFEcha = "";






            let number = 0;
            for (const key in this.productos[0]) {


                if (key == "pesos") {
                    this.pesos = [];
                    let myPeso = [];
                    this.pesos = JSON.parse(this.productos[0]['pesos']);
                    
                    // console.log("arreglarpesos", arreglarPesos);
                  /*  if(arreglarPesos.length <= 4) {
                       this.contador_pesos = arreglarPesos.lenght;
                       this.cd.detectChanges();
                   } 
                   if(arreglarPesos.length > 4) {
                       this.contador_pesos = '4';
                       this.cd.detectChanges();
                   }  */
                   /*  for (let index = 0; index < arreglarPesos.length; index++) {
                        if (arreglarPesos[index] == "") {

                        } else {
                            
                            myPeso.push({ peso: arreglarPesos[index].peso, num_piezas: arreglarPesos[index].num_piezas.toString() });
                        }

                        if (((index + 1) % 4) == 0 && index > 0) {

                           
                            arreglarPesos.push();
                            this.pesos.push(myPeso);
                            myPeso = [];


                        }
                        if (index == arreglarPesos.length - 2) {
                            this.pesos.push(myPeso);
                            // console.log("myPeso",myPeso);
                            //myPeso=[];

                        }

                    } */

                    //console.log("Pesos",this.pesos);
                } else {



                    this.productosKey.push([key]);
                    recogerPalabra = key;
                    recogercadenas = [];


                }

                
                separarFEcha = this.productos[0]['fecha'].split("-");

                let estructurarFEcha = separarFEcha[2] + "-" + separarFEcha[1] + "-" + separarFEcha[0];
                if (number == 0) {

                    this.imprimirService.getAnexo(this.productos[0]['fecha'], 'producto_embolsado').subscribe(resp => {
                        console.log('anexo', resp);
                        
                        try {
                            if (resp[0]['fecha_anexo'] === undefined) {
                                this.anexo = new Date();
                            } else {
                                this.anexo = resp[0]['fecha_anexo'];
                            }
                        } catch (error) {
                            this.anexo = new Date();
                        }
                        try {
                       
                            if( resp[0]['rev'] === undefined ){
                                this.rev = 'X';
                            }else{
                                this.rev = resp[0]['rev'];
                            }
                            } catch (error) {
                                this.rev = 'X';
                            }
                            

                    });
                    number++;
                } else {

                }


                if (key == "id") {

                } else {
                    if (key == "Pesos") {

                    } else {
                        this.myMap.set(key, this.productos[0][key]);
                        if (recogerPalabra.includes("_")) {

                            recogercadenas = key.split("_");
                            recogerPalabra = this.jsUcfirst(recogercadenas[0]) + " " + recogercadenas[1];
                            recogerPalabra = recogerPalabra.replace("_", " ");
                        }
                        try {
                            if (Number.isInteger(parseInt(recogerPalabra.substring(recogerPalabra.length - 1, recogerPalabra.length)))) {
                                // console.log("true");

                                recogerPalabra = this.jsUcfirst(recogerPalabra.slice(0, recogerPalabra.length - 1)) + " " + recogerPalabra.slice(-1);
                            }
                        } catch (error) {

                        }

                    }

                    recogerPalabra = this.jsUcfirst(recogerPalabra);

                    this.estructurado.push(recogerPalabra + " : " + this.productos[0][key]);


                    //this.estructurado.push(recogerPalabra+" : "+this.productos[0][key]);
                }

            }

            //console.log("estructurado", this.estructurado);

        });

    }
    comprobarCalidad( data: any) {
        // console.log("comprobar calidad",data);
        
          let result = new Array();
          let myRespuesta = '';
        /* global_gap
        IGP
        prod_integrado
        residuo */
          if (data.global_gap !== null && data.global_gap !== undefined && data.global_gap.localeCompare('1') == 0 ) {
              result.push('Global gap')
          }
          if (data.IGP !== null && data.IGP !== undefined && data.IGP.localeCompare('1') == 0 ) {
              result.push('IGP')
          }
          if (data.prod_integrado !== null && data.prod_integrado !== undefined && data.prod_integrado.localeCompare('1') == 0 ) {
              result.push('Producción integrada')
          }
          if (data.residuo !== null && data.residuo !== undefined && data.residuo.localeCompare('1') == 0 ) {
              result.push('Residuo 0')
          }
        
          if (result.length == 0 ) {
            return myRespuesta;
          } else {
            return myRespuesta = result.toString();
          }
        }


    jsUcfirst(string) {
        return string.charAt(0).toUpperCase() + string.slice(1);
    }
    imprimir() {
        let o = {
            filename: 'documento.doc',
            area: 'div.googoose',
            margins: '1in',
            headermargin: '0.5in',
            display: 'Print',
            /*    lang: 'es-ES', */
            lang: 'es-ES',
            download: true
        };
        //debugger;


        let res = $(document).googoose(o);
    }
    exportHTML() {
        var header = "<html xmlns:o='urn:schemas-microsoft-com:office:office' " +
            "xmlns:w='urn:schemas-microsoft-com:office:word' " +
            "xmlns='http://www.w3.org/TR/REC-html40'>" +
            "<head><meta charset='utf-8'>" +
            "<style>" +
            "table{" +
            "  border: 1px solid black !important;" +
            "min-width:90% !important" +
            "}" +
            "td,th{" +
            " font-weight: bold;" +
            "padding: 4px;" +
            "text-align: center;" +
            "background-color: white;" +
            "} table-pesos { width: 600px !important }" +
            "</style>" +
            "<title>Export HTML to Word Document with JavaScript</title></head><body>";
        var footer = "</body></html>";
        var sourceHTML = header + document.getElementById("source-html").innerHTML + footer;

        var source = 'data:application/vnd.ms-word;charset=utf-8,' + encodeURIComponent(sourceHTML);
        var fileDownload = document.createElement("a");
        document.body.appendChild(fileDownload);
        fileDownload.href = source;
        fileDownload.download = 'document.doc';
        fileDownload.click();
        document.body.removeChild(fileDownload);
    }

    Export2Doc() {
        //this.convertImagesToBase64();

        var preHtml = "<html xmlns:o='urn:schemas-microsoft-com:office:office' xmlns:w='urn:schemas-microsoft-com:office:word' xmlns='http://www.w3.org/TR/REC-html40'><head><meta charset='utf-8'><title>Export HTML To Doc</title>"
            + "<style>*{font-family: Arial !important';}   .cabecera-informes tr {  border: 1px solid black; }        " + estilos_informes +  "     </style>"
            + "</head><body > <div style=' font-family: Arial !important;'>";
        var postHtml = "</div></body></html>";
        var html = preHtml + document.getElementById('source-html').innerHTML + postHtml;

        var blob = new Blob(['\ufeff', html], {
            type: 'application/msword'
        });

        // Specify link url
        var url = 'data:application/vnd.ms-word;charset=utf-8,' + encodeURIComponent(html);
        let filename = "";
        // Specify file name
        filename = filename ? filename + '.doc' : 'Control_del_producto_embolsado_citricos.doc';

        // Create download link element
        var downloadLink = document.createElement("a");

        document.body.appendChild(downloadLink);

        if (navigator.msSaveOrOpenBlob) {
            navigator.msSaveOrOpenBlob(blob, filename);
        } else {
            // Create a link to the file
            downloadLink.href = url;

            // Setting the file name
            downloadLink.download = filename;

            //triggering the function
            downloadLink.click();
        }

        document.body.removeChild(downloadLink);
    }

    sustituirAcentos(cadena: String) {
        //console.log("cadena",cadena.length);
        var especiales = ["Á", "É", "Í", "Ó", "Ú", "ñ", "á", "é", "í", "ó", "ú"];
        let sustitutos = ["&Aacute", "&Eacute", "IAacute", "&Oacute", "&Uacute", "&ntilde", "&aacute", "&eacute", "&iacute", "&oacute", "&uacute"];
        let nuevaCadena = "";
        let discriminador = false;
        let numero = cadena.length;

        for (let index = 0; index < numero; index++) {
            discriminador = false;
            for (let j = 0; j < especiales.length; j++) {

                if ((cadena.charAt(index)) == especiales[j]) {
                    nuevaCadena += sustitutos[j];
                    discriminador = true;

                }
            }
            //console.log("charAt"+cadena.charAt(index));
            if (discriminador) {

            } else {
                nuevaCadena += cadena.charAt(index);
            }

        }
        return nuevaCadena;

    }

    convertImagesToBase64() {

        let regularImages = document.getElementById("source-html").querySelectorAll("img");

        var canvas = document.createElement('canvas');
        var ctx = canvas.getContext('2d');
        [].forEach.call(regularImages, function (imgElement) {
            // preparing canvas for drawing
            ctx.clearRect(0, 0, canvas.width, canvas.height);
            canvas.width = imgElement.width;
            canvas.height = imgElement.height;
            ctx.drawImage(imgElement, 0, 0);
            // by default toDataURL() produces png image, but you can also export to jpeg
            // checkout function's documentation for more details
            var dataURL = canvas.toDataURL();

            debugger;
            imgElement.setAttribute('src', dataURL);
        })
        canvas.remove();
    }

    cerrar() {
        this.cerrarVentana.emit({ closeWindow: false });
    }


    checkObservaciones(campo: string, value:string ) {
        if( campo.localeCompare('Observaciones') == 0 ) {
            if( value == null || value == undefined ) {
                return false;
            }
            if( value.length <= 0 ) {
                return false;
            }
            return true;
        }
        return true;
    }

    dataURLtoFile(dataurl, filename) {


        var arr = dataurl.split(','),
          mime = arr[0].match(/:(.*?);/)[1],
          bstr = atob(arr[1]),
          n = bstr.length,
          u8arr = new Uint8Array(n);
    
        while (n--) {
          u8arr[n] = bstr.charCodeAt(n);
        }
    
        return new File([u8arr], filename, { type: mime });
      }
    
      handleFiles(e, lugar, remove = false) {
        return new Promise((resolve, reject) => {
          var canvas: any = document.getElementById("canvas");
          var ctx = canvas.getContext("2d");
          var cw = canvas.width;
          var ch = canvas.height;
          var maxW = 270;
          var maxH = 200;
    
    
    
          var img = new Image;
          img.onload = () => {
            // console.log('lugar', lugar);
    
            var iw = img.width;
            var ih = img.height;
            var scale = Math.min((maxW / iw), (maxH / ih));
            var iwScaled = iw * scale;
            var ihScaled = ih * scale;
            canvas.width = iwScaled;
            canvas.height = ihScaled;
            ctx.drawImage(img, 0, 0, iwScaled, ihScaled);
    
            let nuevaEtiqueta = canvas.toDataURL("image/jpeg", 1);
            if (remove) {
              canvas.remove();
            }
    
            // console.log('lugar1', nuevaEtiqueta);
            resolve(nuevaEtiqueta);
    
          }
          img.src = URL.createObjectURL(e);
        })
    
    
    
      }

}